import { useInfiniteQuery, type InfiniteData } from '@tanstack/react-query';
import { getContactActivityFromRest } from '../services/contacts-rest.service';
import type { ContactActivityPagingResult } from '../types/contact-activity.types';

const DEFAULT_PAGE_SIZE = 10;

export const useContactTimeLines = (
  contactId: string,
  options: { enabled?: boolean; pageSize?: number } = {}
) => {
  const pageSize = options.pageSize ?? DEFAULT_PAGE_SIZE;

  return useInfiniteQuery<
    ContactActivityPagingResult,
    Error,
    InfiniteData<ContactActivityPagingResult, string | undefined>,
    readonly ['contact-activity', string, number],
    string | undefined
  >({
    queryKey: ['contact-activity', contactId, pageSize],
    queryFn: ({ pageParam }) =>
      getContactActivityFromRest(contactId, { cursor: pageParam, pageSize }),
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.nextCursor : undefined),
    staleTime: 5 * 60 * 1000,
    enabled: (options.enabled ?? true) && Boolean(contactId),
  });
};
